import { StyledTextInputContainer } from 'grommet/components/TextInput/StyledTextInput';
import styled, { css } from 'styled-components';
import { accent0, gray4 } from '../../globals/colors';
import { bubbleEventMixin, bubbleMixin, compactIconFrameMixin, flexCenterMixin, labeledIconFrameMixin } from '../../styles/mixins';
import alpha from '../../utility/alpha';
import { LabeledIcon } from '../LabeledIcon';

export const LabeledIconStyled = styled(LabeledIcon)`
    ${labeledIconFrameMixin}
    box-shadow: none;
    border-color: ${({ visible }) => visible ? 'white' : 'transparent'};
    img {
        width: 85%;
    }
`;

export const CompactIconStyled = styled(LabeledIcon)`
    ${compactIconFrameMixin}
    box-shadow: none;
    border-color: ${({ visible }) => visible ? accent0 : 'transparent'};
    border-width: thick;
    img {
        width: 85%;
    }
`;

export const counterInputRootCss = css`
    ${bubbleMixin}
    border-color: ${accent0};
    ${flexCenterMixin}
    ${StyledTextInputContainer} {
        ${flexCenterMixin}
    }
`;

export const counterInputInputCss = css`
    font-size: calc(.5rem + 1.25em);
    width: 1.5em;
    height: 1em;
    padding: 0;
    text-align: center;
    background: transparent;
    color: white;
    box-shadow: none;
    border-bottom: 2px solid transparent;
    transition: border-color 150ms;
    &:focus {
        box-shadow: none;
        border-bottom-color: ${alpha(gray4, .5)};
    }
`;

export const PlusMinusButton = styled.button.attrs(() => ({
    type: 'button'
}))`
    ${flexCenterMixin}
    ${bubbleMixin}
    ${bubbleEventMixin}
`;

export const plusMinusButtonIconCss = css`
    color: white;
    height: .75em;
    width: .75em;
`;
